import React from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { Text, Stack } from '@moda/om';
import { FINAL_SALE_SHORT_COPY, FINAL_SALE_TEXT } from '../../../constants';
import { EXTENDED_HOLIDAYS_MESSAGE } from '../../../constants/extendedHolidaysMessage';
import { ReturnPolicy } from '../../../generated/types';
import { getReturnPolicy } from './getReturnPolicy';

interface Props {
  returnPolicy: ReturnPolicy | null;
}

export const ReturnPolicyCopy: React.FC<Props> = ({ returnPolicy }) => {
  const isNewReturnPolicyEnabled = useFeatureFlag('new-return-policy', [
    { default: false },
    { if: true, then: true }
  ]);

  if (!returnPolicy) {
    return null;
  }

  if (returnPolicy === ReturnPolicy.extended_holidays) {
    return <>{EXTENDED_HOLIDAYS_MESSAGE}</>;
  }

  if (returnPolicy === ReturnPolicy.final_sale) {
    return (
      <Stack space={0} direction="horizontal">
        <Text>
          <Text treatment="bold1">{FINAL_SALE_TEXT}</Text>
          {FINAL_SALE_SHORT_COPY}
        </Text>
      </Stack>
    );
  }

  if (returnPolicy === ReturnPolicy.full_refund && isNewReturnPolicyEnabled) {
    return <>Item is returnable within 14 days for a full refund, or 28 days for site credit.</>;
  }

  const { returnDaysNumber, refundMethod } = getReturnPolicy(returnPolicy);

  if (!returnDaysNumber) {
    return null;
  }

  return (
    <>
      {`Item is returnable within ${returnDaysNumber} days ${
        refundMethod ? ` for a ${refundMethod}.` : '.'
      }`}
    </>
  );
};
